var render = function render(){var _vm=this,_c=_vm._self._c;return _c('core-modal',{attrs:{"type":"text","is-large":true,"loading":_vm.is.loading,"hideFoot":true},on:{"close":_vm.onClose},scopedSlots:_vm._u([{key:"head",fn:function(){return [_vm._v(" Terms and conditions ")]},proxy:true},{key:"default",fn:function(){return [_c('div',{domProps:{"innerHTML":_vm._s(_vm.content)}})]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }